module.exports = __webpack_public_path__ + "img/upkot.5a2c26fe.svg";